<template>
  <section id="portfolio" class="inner portfolio">
    <div class="container-fluid p-0 fullheight">
      <div class="row g-0 fullheight">
        <!-- Portfolio Section Content Start -->
        <div class="col-12 col-xl-8 inner__content">
          <!-- desktop shadow -->
          <div class="desktop-shadow"></div>
          <!-- inner section blocks -->
          <div class="inner__blocks">
            <!-- Section Container - Section Title Start -->
            <div class="inner__container">
              <div class="content-block">
                <span class="section__subtitle">Portfolio</span>
                <h2>
                  What have I made in these 3 years?.
                </h2>
                <p class="section__text">
                  I made a lot of stuff but most of it I threw away because I didn't need it anymore. I only keep a few for memories that prove my struggle process. I will never update these results again to maintain authenticity and to see how my code evolves over time
                </p>
              </div>
            </div>
            <!-- Section Container - Section Title End -->

            <!-- Section Container - Gallery Start -->
            <div class="inner__container">
              <div class="content-block grid-block">
                <div class="container-fluid px-4 works__gallery">
                  <div
                    class="row gx-5 my-gallery"
                    itemscope
                    itemtype="http://schema.org/ImageGallery"
                  >
                    <!-- Works Gallery Single Item Start -->
                    <figure
                      class="col-12 col-md-6 my-gallery__item"
                      itemprop="associatedMedia"
                      itemscope
                      itemtype="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://dummyimage.com/1000x1000/dedede/636363"
                        data-image="https://dummyimage.com/1000x1000/dedede/636363"
                        class="my-gallery__link block-rounded-l"
                        itemprop="contentUrl"
                        data-size="1000x1000"
                      >
                        <img
                          src="https://dummyimage.com/1000x1000/dedede/636363"
                          class="my-gallery__image"
                          itemprop="thumbnail"
                          alt="Image description"
                        />
                      </a>
                      <figcaption
                        class="my-gallery__description block-rounded-l"
                        itemprop="caption description"
                      >
                        <h4 class="dark">
                          PHP - OCR KTP
                          <small>Backend programming</small>
                        </h4>
                        <p>
                          Mauris porttitor lobortis ligula, quis molestie lorem
                          scelerisque eu. Morbi aliquam enim odio, a mollis
                          ipsum tristique eu.
                        </p>
                      </figcaption>
                    </figure>
                    <!-- Works Gallery Single Item End -->

                    <!-- Works Gallery Single Item Start -->
                    <figure
                      class="col-12 col-md-6 my-gallery__item"
                      itemprop="associatedMedia"
                      itemscope
                      itemtype="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://dummyimage.com/1000x1000/636363/ffffff"
                        data-image="https://dummyimage.com/1000x1000/636363/ffffff"
                        class="my-gallery__link block-rounded-l"
                        itemprop="contentUrl"
                        data-size="1000x1000"
                      >
                        <img
                          src="https://dummyimage.com/1000x1000/636363/ffffff"
                          class="my-gallery__image"
                          itemprop="thumbnail"
                          alt="Image description"
                        />
                      </a>
                      <figcaption
                        class="my-gallery__description block-rounded-l"
                        itemprop="caption description"
                      >
                        <h4>
                          Laravel - Alumni school profile
                          <small>Web programming</small>
                        </h4>
                        <p>
                          Mauris porttitor lobortis ligula, quis molestie lorem
                          scelerisque eu. Morbi aliquam enim odio, a mollis
                          ipsum tristique eu.
                        </p>
                      </figcaption>
                    </figure>
                    <!-- Works Gallery Single Item End -->

                    <!-- Works Gallery Single Item Start -->
                    <figure
                      class="col-12 col-md-6 my-gallery__item"
                      itemprop="associatedMedia"
                      itemscope
                      itemtype="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://dummyimage.com/1000x1000/636363/ffffff"
                        data-image="https://dummyimage.com/1000x1000/636363/ffffff"
                        class="my-gallery__link block-rounded-l"
                        itemprop="contentUrl"
                        data-size="1000x1000"
                      >
                        <img
                          src="https://dummyimage.com/1000x1000/636363/ffffff"
                          class="my-gallery__image"
                          itemprop="thumbnail"
                          alt="Image description"
                        />
                      </a>
                      <figcaption
                        class="my-gallery__description block-rounded-l"
                        itemprop="caption description"
                      >
                        <h4>
                          Laravel - CMS music distribution
                          <small>Web programming</small>
                        </h4>
                        <p>
                          Mauris porttitor lobortis ligula, quis molestie lorem
                          scelerisque eu. Morbi aliquam enim odio, a mollis
                          ipsum tristique eu.
                        </p>
                      </figcaption>
                    </figure>
                    <!-- Works Gallery Single Item End -->

                    <!-- Works Gallery Single Item Start -->
                    <figure
                      class="col-12 col-md-6 my-gallery__item"
                      itemprop="associatedMedia"
                      itemscope
                      itemtype="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://dummyimage.com/1000x1000/dedede/636363"
                        data-image="https://dummyimage.com/1000x1000/dedede/636363"
                        class="my-gallery__link block-rounded-l"
                        itemprop="contentUrl"
                        data-size="1000x1000"
                      >
                        <img
                          src="https://dummyimage.com/1000x1000/dedede/636363"
                          class="my-gallery__image"
                          itemprop="thumbnail"
                          alt="Image description"
                        />
                      </a>
                      <figcaption
                        class="my-gallery__description block-rounded-l"
                        itemprop="caption description"
                      >
                        <h4 class="dark">
                          Laravel - SPP SMK
                          <small>Web programming</small>
                        </h4>
                        <p>
                          Mauris porttitor lobortis ligula, quis molestie lorem
                          scelerisque eu. Morbi aliquam enim odio, a mollis
                          ipsum tristique eu.
                        </p>
                      </figcaption>
                    </figure>
                    <!-- Works Gallery Single Item End -->

                    <!-- Works Gallery Single Item Start -->
                    <figure
                      class="col-12 col-md-6 my-gallery__item"
                      itemprop="associatedMedia"
                      itemscope
                      itemtype="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://dummyimage.com/1000x1000/dedede/636363"
                        data-image="https://dummyimage.com/1000x1000/dedede/636363"
                        class="my-gallery__link block-rounded-l"
                        itemprop="contentUrl"
                        data-size="1000x1000"
                      >
                        <img
                          src="https://dummyimage.com/1000x1000/dedede/636363"
                          class="my-gallery__image"
                          itemprop="thumbnail"
                          alt="Image description"
                        />
                      </a>
                      <figcaption
                        class="my-gallery__description block-rounded-l"
                        itemprop="caption description"
                      >
                        <h4 class="dark">
                          Laravel - Kayana solusi indo
                          <small>Web programming</small>
                        </h4>
                        <p>
                          Mauris porttitor lobortis ligula, quis molestie lorem
                          scelerisque eu. Morbi aliquam enim odio, a mollis
                          ipsum tristique eu.
                        </p>
                      </figcaption>
                    </figure>
                    <!-- Works Gallery Single Item End -->

                    <!-- Works Gallery Single Item Start -->
                    <figure
                      class="col-12 col-md-6 my-gallery__item"
                      itemprop="associatedMedia"
                      itemscope
                      itemtype="http://schema.org/ImageObject"
                    >
                      <a
                        href="https://dummyimage.com/1000x1000/636363/ffffff"
                        data-image="https://dummyimage.com/1000x1000/636363/ffffff"
                        class="my-gallery__link block-rounded-l"
                        itemprop="contentUrl"
                        data-size="1000x1000"
                      >
                        <img
                          src="https://dummyimage.com/1000x1000/636363/ffffff"
                          class="my-gallery__image"
                          itemprop="thumbnail"
                          alt="Image description"
                        />
                      </a>
                      <figcaption
                        class="my-gallery__description block-rounded-l"
                        itemprop="caption description"
                      >
                        <h4>
                          Vue JS - Anime Stream
                          <small>Web programming</small>
                        </h4>
                        <p>
                          Mauris porttitor lobortis ligula, quis molestie lorem
                          scelerisque eu. Morbi aliquam enim odio, a mollis
                          ipsum tristique eu.
                        </p>
                      </figcaption>
                    </figure>
                    <!-- Works Gallery Single Item End -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Section Container - Gallery End -->
          </div>
        </div>
        <!-- Portfolio Section Content End -->

        <!-- Portfolio Section Media Start -->
        <div class="col-12 col-xl-4 inner__media">
          <!-- Portfolio Section Image Background Start -->
          <div class="image media-image-portfolio"></div>
          <!-- Portfolio Section Image Background End -->
        </div>
        <!-- Portfolio Section Media End -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PortfolioSection",
};
</script>